import {IntermediatePart} from "../../intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import Appliance from "../../parts/appliance";

export default class TopHandle extends IntermediatePart {

  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'top_handle';
    this.partName = 'Top Handle';
    this.canBeDisabled = true;
    this.layerPriority = 2;
    this.translateId = "visualizer.kitchen.cabinet.top_handle";
  }

  load(dbFeature) {
    if (!dbFeature.metaData["HoodType"]) {
      dbFeature.metaData["HoodType"] = ["All"]// it can be "Wood"
    }
    if (!dbFeature.metaData["CabinetLayout"]) {
      dbFeature.metaData["CabinetLayout"] = ["All"]
    }
    if (!dbFeature.metaData["DoorSet"]) {
      dbFeature.metaData["DoorSet"] = ["All"]
    }
    const parts = dbFeature.metaData && dbFeature.metaData["Parts"];
    if (parts) {
      const partNumber = +dbFeature.metaData["Part"][0];
      return super.load_(dbFeature, new TopHandle(false, partNumber),
        true, partNumber === 1 ? 'features' : 'featuresParts');
    } else {
      return super.load_(dbFeature, new TopHandle());
    }
  }

  disabledClick() {
    const topCabinet = this.getParent().topCabinet;
    if (topCabinet && topCabinet.disabled && !this.disabled) {
      topCabinet.disabled = this.disabled;
      topCabinet.activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
      const crownMolding = this.getParent().crownMolding;
      if (crownMolding) {
        crownMolding.disabled = this.disabled;
      }
    }
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(true), filteredAvailableFeatures);
    const topCabinet = this.getParent().topCabinet;
    if (topCabinet && topCabinet.activeFeature && topCabinet.activeFeature.partName.includes("Portico White Chocolate")) {
      return []
    }
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {

    const topCabinet = this.getParent().topCabinet;
    if (topCabinet && (topCabinet.disabled || !topCabinet.featureGroupEnabled)
      || (topCabinet && topCabinet.activeFeature && topCabinet.activeFeature.partName.includes("Portico White Chocolate"))) {
      super.hideLayers();
      return
    }
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      this.checkIfFeaturePartIsMatching();
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  getArrayOfConditions() {

    const cabinetParent = this.getParent();
    let cabinetLayout = ["All"];
    let doorSet = ["All"];
    if (cabinetParent.topCabinet && cabinetParent.topCabinet.activeFeature) {
      if (cabinetParent.topCabinet.activeFeature.metaData["CabinetLayout"]) {
        cabinetLayout = cabinetParent.topCabinet.activeFeature.metaData["CabinetLayout"][0]
      }
      if (cabinetParent.topCabinet.activeFeature.metaData["DoorSet"]) {
        doorSet = cabinetParent.topCabinet.activeFeature.metaData["DoorSet"][0];
      }
    }

    return [{
      propName: "Appliance",
      propValue: cabinetParent.getTopCabinetApplianceType()
    }, {
      propName: 'RoomLayout',
      propValue: cabinetParent.layout.getCurrentLayoutAbbreviation()
    },{
      propName: 'CabinetLayout',
      propValue: cabinetLayout
    },{
      propName: "DoorSet",
      propValue: doorSet
    }];
  }

  getActiveFeatureConditions() {
    let hoodType = ["All"];
    const cabinetParent = this.getParent();
    const isHood = cabinetParent.getTopCabinetApplianceType() === "Hood";
    const applianceParent = cabinetParent.layout.parts[Appliance.id];
    if (isHood && applianceParent.hood && applianceParent.hood.activeFeature
      && applianceParent.hood.activeFeature.metaData && applianceParent.hood.activeFeature.metaData["HoodType"]) {
      hoodType = applianceParent.hood.activeFeature.metaData["HoodType"][0];
    }
    const conditions = this.getArrayOfConditions();
    conditions.push({
      propName: "HoodType",
      propValue: hoodType
    });
    return conditions
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    const matchingFeatureExist = this.tryToSetTheSameFeature(filteredFeatures, null);
    if (!matchingFeatureExist) {
      this.activeFeature = filteredFeatures[0];
    }
    this.activeFeatureParts = this.setActiveFeatureParts();
  }

  setActiveFeatureParts(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    return this.getActiveFeaturePartsAccordingToActiveFeature(fromFeature, activeFeatureConditions);
  }

  setZIndex(zIndexes) {
    if (zIndexes) {
      const zIndex = zIndexes.Cabinet.TopHandle;
      const zIndex2 = zIndexes.Cabinet.TopHandle2;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.activeFeatureParts && this.activeFeatureParts.length) {
        this.activeFeatureParts.forEach((activeFeaturePart) => {
          if (activeFeaturePart && activeFeaturePart.layer) {
            activeFeaturePart.layer.zIndex = zIndex2;
          }
        })
      }
    }
  }
}
